import React, { useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

import classes from "./Inputs.module.css";

const Inputs = () => {
  const { t } = useTranslation();
  const [nameMessage, setNameMessage] = useState("");
  const [phoneNumberMessage, setPhoneNumberMessage] = useState("");

  const token = "6376242475:AAGK4MekEeokENyrBzO69QceX0Wjf3C0AGQ";

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const chatId = 795052103;

      const url = `https://api.telegram.org/bot${token}/sendMessage`;

      const response = await axios.post(url, {
        chat_id: chatId,
        text: `UZ: Yangi habar keldi:\nIsm: ${nameMessage} , telefon raqam: ${phoneNumberMessage}.\nРу: Пришло новоё сообщение:\nИмя: ${nameMessage} , телефон номер: ${phoneNumberMessage}.`,
      });

      setNameMessage("");
      setPhoneNumberMessage("");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className={classes["wrapper"]}>
      <h3 className={classes["title"]}>{t("Join us")}</h3>
      <form onSubmit={handleSubmit}>
        <div className={classes["input-wrapper"]}>
          <input
            placeholder="Abdullokh"
            className={classes["input"]}
            type="text"
            value={nameMessage}
            onChange={(e) => setNameMessage(e.target.value)}
            required
          />
          <input
            placeholder="+998988880448"
            className={classes["input"]}
            type="number"
            value={phoneNumberMessage}
            onChange={(e) => setPhoneNumberMessage(e.target.value)}
            required
          />
          <button type="submit" className={classes["send-button"]}>
            {t("Send")}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Inputs;
